import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mc ofs mt20"
}
const _hoisted_2 = {
  key: 0,
  class: "fs14 fl mt5 ml10"
}
const _hoisted_3 = {
  key: 1,
  class: "fr mt10"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = {
  key: 2,
  class: "with_white_bg rad10 mt20 centered pad5"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "fs12 fw600 pad5 text-left" }, "選択中のテンプレ:", -1)
const _hoisted_7 = { class: "mb10 mt20" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "mr8" }, "デフォルトに設定", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  class: "centered",
  style: {"margin-top":"100px"}
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "grey" }, "作成したテンプレがありません。", -1)
const _hoisted_17 = ["src"]
const _hoisted_18 = { key: 2 }
const _hoisted_19 = {
  class: "w100 mt10 rad10",
  style: {"border":"1px solid #efefef"}
}
const _hoisted_20 = ["src"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "fs11" }, "キャンセル", -1)
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_24 = { class: "w100" }
const _hoisted_25 = {
  class: "w55 fl",
  style: {"padding":"20px 10px"}
}
const _hoisted_26 = { class: "w100" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_32 = { key: 0 }
const _hoisted_33 = ["value"]
const _hoisted_34 = {
  class: "w45 fl",
  style: {"padding":"20px 10px","min-height":"300px"}
}
const _hoisted_35 = {
  key: 0,
  class: "rad10 fs13 fw600 dgrey yellowBg pad10"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "fw400 grey w100" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fr" }, "でプレビューしています。"),
  /*#__PURE__*/_createElementVNode("div", { class: "clear" })
], -1)
const _hoisted_37 = {
  key: 1,
  class: "fw400 dgrey"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "fs14 fw600" }, "プレビュー", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_43 = {
  class: "previewContent fs13 kaigyo lskyblueBg w100 rad10",
  style: {"padding":"20px 10px","min-height":"300px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TemplateCell = _resolveComponent("TemplateCell")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_LblueListContent = _resolveComponent("LblueListContent")!

  return (_openBlock(), _createElementBlock("div", {
    class: "w100",
    style: _normalizeStyle({ height: _ctx.pageFrom == `settings` ? `auto` : `90vh` })
  }, [
    (_ctx.mode == `select`)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h3", {
            class: _normalizeClass(`fs18 ls1 mc fw600 ${_ctx.pageFrom == `settings` ? `ml5 fl` : ` centered`}`)
          }, _toDisplayString(_ctx.pageTitle || `テンプレを選択`), 3),
          (_ctx.pageFrom == `settings`)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, " 「フォーム事前埋め」で送信する定型文を作成することができます。 "))
            : _createCommentVNode("", true),
          (!_ctx.selectedTmp)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("button", {
                  class: "pointer centered circle_button skyblueBg fs13 rad8 fw600 padw10",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createNewTemplate && _ctx.createNewTemplate(...args)))
                }, " テンプレを新規作成 ")
              ]))
            : _createCommentVNode("", true),
          _hoisted_4,
          (_ctx.selectedTmp)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_TemplateCell, {
                  class: "text-left",
                  tmp: _ctx.selectedTmp,
                  showDeleteButton: false,
                  showEditButton: false
                }, null, 8, ["tmp"]),
                _createElementVNode("div", _hoisted_7, [
                  (_ctx.rcm.room && _ctx.rcm.room.default_message_template_id != _ctx.selectedTmp.id)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "mc pointer centered circle_button fs13 rad8 fw600 padw5 mr5",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addDefaultTemplate && _ctx.addDefaultTemplate(...args)))
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(`/assets/icons/pin_on.png`),
                          width: "25"
                        }, null, 8, _hoisted_8),
                        _hoisted_9
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "mc pointer centered circle_button greyBg fs13 rad8 fw600 padw10",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.reselectTemp && _ctx.reselectTemp(...args)))
                  }, " テンプレを選びなおす "),
                  _hoisted_10
                ]),
                _hoisted_11
              ]))
            : _createCommentVNode("", true),
          (!_ctx.selectedTmp)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (!_ctx.tmps)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13))
                  : (_ctx.tmps.length == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _hoisted_16,
                          _createElementVNode("img", {
                            src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                            width: "40",
                            height: "40"
                          }, null, 8, _hoisted_17)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tmps, (tmp, tmpindex) => {
                            return (_openBlock(), _createBlock(_component_TemplateCell, {
                              key: `${tmpindex}${tmp.id}`,
                              tmp: tmp,
                              onSelect: _ctx.selectTmp,
                              onDeleteTmp: _ctx.deleteTmp,
                              onEditTmp: _ctx.editTmp,
                              showDeleteButton: _ctx.showEditButton || false,
                              showEditButton: _ctx.showEditButton || false
                            }, null, 8, ["tmp", "onSelect", "onDeleteTmp", "onEditTmp", "showDeleteButton", "showEditButton"]))
                          }), 128))
                        ])
                      ]))
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_ctx.mode == `create`)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            style: _normalizeStyle({ height: _ctx.pageFrom == `settings` ? `auto` : `400px` }),
            class: _normalizeClass(`w100 posRe  mt20 ${_ctx.pageFrom == `settings` ? `` : `ofs`}`)
          }, [
            _createElementVNode("h3", {
              class: _normalizeClass(`fs16 ls1 mc centered fw600 ${_ctx.pageFrom == `settings` ? `text-left fl ml10` : ``}`)
            }, _toDisplayString(_ctx.currentTmp.id == `newId` ? `テンプレを追加` : `テンプレを編集`), 3),
            (_ctx.pageFrom == `settings`)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "fr pointer mr20",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.backTemplates && _ctx.backTemplates(...args)))
                }, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
                    width: "50",
                    height: "50"
                  }, null, 8, _hoisted_20),
                  _hoisted_21
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "fr pointer mt10 mr20",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.backTemplates && _ctx.backTemplates(...args)))
                }, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/leftArrow.png`),
                    width: "15",
                    height: "19",
                    style: {"margin-top":"-4px"}
                  }, null, 8, _hoisted_22),
                  _createTextVNode(" 戻る ")
                ])),
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createVNode(_component_MdTextfieldTag, {
                    name: "テンプレート名",
                    style: {"height":"56px","min-width":"100%"},
                    fieldStyle: "min-width:100%;",
                    class: "fl fs14",
                    value: _ctx.currentTmp.title,
                    onInputValue: _ctx.inputTitle,
                    required: ""
                  }, null, 8, ["value", "onInputValue"]),
                  _hoisted_28,
                  _hoisted_29,
                  _createVNode(_component_MdTextfieldTag, {
                    name: "メールタイトル",
                    style: {"height":"56px","min-width":"100%"},
                    fieldStyle: "min-width:100%;",
                    class: "fl fs14",
                    value: _ctx.currentTmp.subject,
                    onInputValue: _ctx.inputSubject,
                    required: ""
                  }, null, 8, ["value", "onInputValue"]),
                  _hoisted_30,
                  _hoisted_31,
                  _createElementVNode("p", {
                    class: "fw600 fs12 underline pointer",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleVariableList && _ctx.toggleVariableList(...args)))
                  }, "変数から追加"),
                  (_ctx.openVariableList)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _createElementVNode("div", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.titles, (title, locindex) => {
                            return (_openBlock(), _createBlock(_component_LblueListContent, {
                              key: locindex,
                              name: title,
                              value: title,
                              class: _normalizeClass(`fl mr10 mb10`),
                              type: `underline`,
                              display: true,
                              showDeleteButton: false,
                              onClickContent: ($event: any) => (_ctx.selectVariable(title))
                            }, null, 8, ["name", "value", "onClickContent"]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("textarea", {
                    style: {"resize":"none","outline":"none","height":"300px","margin-top":"15px"},
                    placeholder: "先日はメールいただきましてありがとうございます。",
                    class: "fl fs14 roundForm mw100 TemplateTextarea",
                    ref: "TemplateTextarea",
                    id: `TemplateTextarea`,
                    onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.inputContent && _ctx.inputContent(...args))),
                    value: _ctx.text
                  }, null, 40, _hoisted_33)
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", {
                  class: "pointer centered circle_button skyblueBg fs12 rad8 fw600 mb20",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.create && _ctx.create(...args)))
                }, "保存"),
                _createElementVNode("div", null, [
                  (_ctx.currentMembers && _ctx.currentMembers.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentMembers, (member, memberindex) => {
                          return (_openBlock(), _createElementBlock("div", { key: memberindex }, " 出席者-" + _toDisplayString(memberindex + 1) + ": " + _toDisplayString(member.name), 1))
                        }), 128)),
                        _createElementVNode("div", null, "オーナー名: " + _toDisplayString(_ctx.owner ? _ctx.owner.name : ``), 1),
                        _hoisted_36
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_37, "※ 出席者が選択されていません。"))
                ]),
                _hoisted_38,
                _hoisted_39,
                _hoisted_40,
                _hoisted_41,
                _hoisted_42,
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.afterText), 1)
                ])
              ])
            ])
          ], 6))
        : _createCommentVNode("", true)
  ], 4))
}